/**
 * Фотосессии: группировка медиа модели.
 */
import { apiDelete, apiJson } from './client.js';

export async function getPhotoSessions(modelId) {
  return apiJson(`/admin/models/${modelId}/photo-sessions`, {}, 'Не удалось загрузить фотосессии');
}

export async function createPhotoSession(modelId, name, is_script = false, options = {}) {
  const body = { name, is_script }
  if (options.description !== undefined) body.description = options.description
  if (options.selection_tags !== undefined) body.selection_tags = options.selection_tags
  if (options.paid_sexting_config !== undefined) body.paid_sexting_config = options.paid_sexting_config
  return apiJson(
    `/admin/models/${modelId}/photo-sessions`,
    { method: 'POST', body: JSON.stringify(body) },
    'Не удалось создать фотосессию'
  );
}

export async function getPhotoSession(modelId, sessionId) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}`,
    {},
    'Не удалось загрузить фотосессию'
  );
}

export async function updatePhotoSession(modelId, sessionId, { name, description, selection_tags, is_script, time_tag, paid_sexting_config }) {
  const body = {}
  if (name !== undefined) body.name = name
  if (description !== undefined) body.description = description
  if (selection_tags !== undefined) body.selection_tags = selection_tags
  if (is_script !== undefined) body.is_script = is_script
  if (time_tag !== undefined) body.time_tag = time_tag
  if (paid_sexting_config !== undefined) body.paid_sexting_config = paid_sexting_config
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}`,
    { method: 'PATCH', body: JSON.stringify(body) },
    'Не удалось обновить фотосессию'
  );
}

export async function deletePhotoSession(modelId, sessionId) {
  await apiDelete(`/admin/models/${modelId}/photo-sessions/${sessionId}`, 'Не удалось удалить фотосессию');
}

/** Переставить фотосессии модели: порядок id в массиве = новое sort_order (0-based).
 *  session_ids — ПОЛНЫЙ набор сессий модели без дубликатов. */
export async function reorderPhotoSessions(modelId, sessionIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/reorder`,
    { method: 'POST', body: JSON.stringify({ session_ids: sessionIds }) },
    'Не удалось изменить порядок фотосессий'
  );
}

export async function addMediaToPhotoSession(modelId, sessionId, mediaIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media`,
    { method: 'POST', body: JSON.stringify({ media_ids: mediaIds }) },
    'Не удалось добавить медиа в фотосессию'
  );
}

export async function removeMediaFromPhotoSession(modelId, sessionId, mediaId) {
  await apiDelete(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media/${mediaId}`,
    'Не удалось удалить медиа из фотосессии'
  );
}

/** Изменить порядок медиа внутри фотосессии. */
export async function reorderPhotoSessionMedia(modelId, sessionId, mediaIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/reorder`,
    { method: 'POST', body: JSON.stringify({ media_ids: mediaIds }) },
    'Не удалось изменить порядок'
  );
}

/** Переместить медиа в сессию или отвязать (photoSessionId = null). */
export async function moveMediaToSession(modelId, mediaIds, photoSessionId) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/move-media`,
    {
      method: 'POST',
      body: JSON.stringify({ media_ids: mediaIds, photo_session_id: photoSessionId }),
    },
    'Не удалось переместить медиа'
  );
}

// --- Media groups ---

export async function createMediaGroup(modelId, sessionId, name = '') {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups`,
    { method: 'POST', body: JSON.stringify({ name }) },
    'Не удалось создать группу'
  );
}

export async function updateMediaGroup(modelId, sessionId, groupId, { name, description, price_min, price_max }) {
  const body = {};
  if (name !== undefined) body.name = name;
  if (description !== undefined) body.description = description;
  if (price_min !== undefined) body.price_min = price_min;
  if (price_max !== undefined) body.price_max = price_max;
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/${groupId}`,
    { method: 'PATCH', body: JSON.stringify(body) },
    'Не удалось обновить группу'
  );
}

export async function deleteMediaGroup(modelId, sessionId, groupId) {
  await apiDelete(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/${groupId}`,
    'Не удалось удалить группу'
  );
}

export async function reorderMediaGroups(modelId, sessionId, groupIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/reorder`,
    { method: 'POST', body: JSON.stringify({ group_ids: groupIds }) },
    'Не удалось изменить порядок групп'
  );
}

export async function addMediaToGroup(modelId, sessionId, groupId, mediaIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/${groupId}/media`,
    { method: 'POST', body: JSON.stringify({ media_ids: mediaIds }) },
    'Не удалось добавить медиа в группу'
  );
}

export async function removeMediaFromGroup(modelId, sessionId, groupId, mediaId) {
  await apiDelete(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/${groupId}/media/${mediaId}`,
    'Не удалось убрать медиа из группы'
  );
}

export async function reorderGroupMedia(modelId, sessionId, groupId, mediaIds) {
  return apiJson(
    `/admin/models/${modelId}/photo-sessions/${sessionId}/media-groups/${groupId}/reorder`,
    { method: 'POST', body: JSON.stringify({ media_ids: mediaIds }) },
    'Не удалось изменить порядок медиа'
  );
}
